<div class="">
  <mat-form-field class="!w-[100%]" appearance="outline" [class.mat-form-field-invalid]="control.invalid && control.touched">
    <mat-label>{{label}}</mat-label>
    <input
      matInput
      [ngxTimepicker]="timepicker"
      [formControl]="control"
      [required]="required"
      [readonly]="readonly"
      [placeholder]="placeholder"
      [format]="format"
      (input)="timePicker()"
    />
    <mat-icon matSuffix (click)="timepicker.open()" class="cursor-pointer">access_time</mat-icon>
    <ngx-material-timepicker
    #timepicker
  ></ngx-material-timepicker>
  
  </mat-form-field>
  <mat-error
    *ngIf="control.invalid && control.touched"
    class="relative top-[-15px]"
  >
 {{errorMessage}}
  </mat-error>
</div>
